
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import MembershipHeroSection from './components/MembershipHeroSection';
import MembershipTypesSection from './components/MembershipTypesSection';
import BenefitsSection from './components/BenefitsSection';
import TestimonialsSection from './components/TestimonialsSection';
import ApplicationSection from './components/ApplicationSection';

export default function Membership() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <MembershipHeroSection />
        <MembershipTypesSection />
        <BenefitsSection />
        <TestimonialsSection />
        <ApplicationSection />
      </main>
      <Footer />
    </div>
  );
}
